import React from 'react';
import axios from './../../../constants/axios';
import { Button, Table } from 'react-bootstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';

class ContactStock extends React.Component {

   constructor(props, context) {
      super(props, context);
      this.state = {
         stockItems: [],
         lastFewDays: null,
      };
   }

   componentDidMount() {
      const { contactId } = this.props.params;
      axios.get('contacts/vendors/stockItems/' + contactId)
         .then((res) => {
            this.setState({
               stockItems: res.data.results,
               lastFewDays: moment(res.data.lastFewDays),
            });
         });
   }

   handleDateChange = (date) => {
      this.setState({
         lastFewDays: date
      });
   };

   getSaleStockWithSaleCount = () => {
      const { lastFewDays } = this.state;
      const { contactId } = this.props.params;
      if (lastFewDays) {
         axios.get('contacts/vendors/stockItems/' + contactId + `?lastFewDays=${lastFewDays.format('YYYY-MM-DD')}`)
            .then((res) => {
               this.setState({
                  stockItems: res.data.results,
                  lastFewDays: moment(res.data.lastFewDays),
               });
            });
      }
   };

   render() {
      return (
         <div>
            <h4>Stock And Sale Report</h4>
            <div>
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.lastFewDays}
                  placeholderText="Select Start Date"
                  onChange={this.handleDateChange} />
               <Button onClick={() => this.getSaleStockWithSaleCount()} >Get Stocks</Button>
            </div>
            <Table striped bordered condensed >
               <thead>
               <tr>
                  <th>Stock Id</th>
                  <th>Item Id</th>
                  <th>Item</th>
                  <th>Avg Purchase Price</th>
                  <th>On Hand Unit</th>
                  <th>Damage Unit</th>
                  <th>Unit Sold</th>
               </tr>
               </thead>

               <tbody>
               {this.state.stockItems.map((item) => (
                  <tr key={item.id} >
                     <td>{item.id}</td>
                     <td>{item.item_id}</td>
                     <td>{item.name}</td>
                     <td>{item.avg_purchase_price}</td>
                     <td>{item.unit_on_hand}</td>
                     <td>{item.damage_unit}</td>
                     <td>{item.saleUnit}</td>
                  </tr>
               ))}
               </tbody>
            </Table>
         </div>
      );
   }
}

ContactStock.propTypes = {
   params: React.PropTypes.object,
};
ContactStock.contextTypes = {
   router: React.PropTypes.object.isRequired
};


export default ContactStock;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactDetail/ContactStock.js
 **/